// extracted by mini-css-extract-plugin
module.exports = {"modelMainTable":"src-pages-ModelMainTable-styles-module__modelMainTable--1yjXJ"};